// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__19uO0","overflowing":"ReadFullNote_overflowing__19O5a"};